import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from '../../../BlogMetadata.module.scss'

interface SummaryFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  label?: string
}

export const SummaryField: React.FC<SummaryFieldProps> = ({ value, onChange, label = 'Summary' }) => (
  <div>
    <label className={Styles.textFieldLabel}>{label}</label>
    <div className={Styles.summaryInput}>
      <Input
        name="summary"
        placeholder={`Enter a ${label.toLowerCase()} for your blog post`}
        value={value || ''}
        onChange={onChange}
        size="md"
        isTextarea={true}
        rows={4}
      />
    </div>
  </div>
)
